/* ============================================================
   SPORT ZONE — product page enhancements
   ============================================================
   Clamps the product description and adds a Read more / Read less
   toggle. Mobile first: the description sits between the price and
   the variant picker, so clamping it is what keeps
   price -> variants -> Add to cart within thumb reach.

   Why not the theme's own show-more-component: it requires
   `showMoreItems` refs and works by hiding discrete child elements.
   A merchant description is often a single <p>, which gives it
   nothing to hide, so it cannot do a line clamp.

   Why JS at all: the toggle is only injected when the copy actually
   overflows. CSS cannot measure overflow, so a pure-CSS version
   would show a dead "Read more" under one-line descriptions.

   Styles: assets/base.css  ->  "PRODUCT PAGE REFRESH" block
   ============================================================ */

(() => {
  const LABEL_MORE = 'Read more';
  const LABEL_LESS = 'Read less';

  /** Overflow smaller than this is treated as "it fits". */
  const OVERFLOW_TOLERANCE = 8;

  const enhanceDescription = (root) => {
    const details = root.querySelector?.('.product-details');
    if (!details) return;

    // The description is the rich-text block inside the details column.
    const description = details.querySelector('rte-formatter');
    if (!description || description.dataset.szReadMore) return;
    description.dataset.szReadMore = 'init';

    // Clamp first, then measure: the clamp is what creates the overflow.
    description.classList.add('sz-desc');
    if (!description.id) description.id = 'sz-product-description';

    requestAnimationFrame(() => {
      const overflows = description.scrollHeight - description.clientHeight > OVERFLOW_TOLERANCE;

      if (!overflows) {
        // Short copy: drop the clamp and add no control at all.
        description.classList.remove('sz-desc');
        return;
      }

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'sz-desc__toggle';
      toggle.textContent = LABEL_MORE;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', description.id);

      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('sz-desc--open');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? LABEL_LESS : LABEL_MORE;
      });

      description.insertAdjacentElement('afterend', toggle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceDescription(document));
  } else {
    enhanceDescription(document);
  }

  // Re-run when the theme editor reloads the section.
  document.addEventListener('shopify:section:load', (event) => {
    enhanceDescription(event.target ?? document);
  });
})();